const moment = require("moment");
const env = require("app/services/env");

const wrapper = document.querySelector('.body-wrapper');
const year    = moment().year();
const key     = 'closed_' + year; // Local storage key

function valentinesBar() {
    const bar = document.getElementById('valentines-bar');

    if (!wrapper || !bar) return; // The bar doesnt' exist on the page

    // Dates
    const valentines = moment([year, 1, 14]); // months start with 0, so 1 is Feb
    const start      = moment([year, 1, 1]);
    const end        = moment([year, 1, 15]).endOf('day');

    // Don't show if:
    // user has closed the bar before OR
    // "NOW" is not between 1st - 16th Feb
    if (localStorage.getItem('cta-bar') === key) return;
    if (!moment().isBetween(start, end)) return;

    // Display the bar
    displayBar(bar);

    if (moment().isBetween(valentines, end)) {
        setContent(
            '.valentines-text', valentines,
             translate('Husk det er Valentinsdag i dag. Bestil din kærlige hilsen nu! Klik her'),
            translate('Glemte du Valentinsdag? Du kan stadig bestille en kærlig hilsen nu! Klik her')
        );

        return;
    }

    addCloseEvent(
        bar,
        document.getElementById('close-cta-bar'),
        getInterval(valentines, document.getElementById("timer")),
        'cta-bar'
    );
}

function topbanner() {

    const bar = document.getElementById('topbanner-bar');
    const data = env.get('topbanner');

    if (!wrapper || !bar) return; // The bar doesnt' exist on the page

    if(!data) {
        return;
    }

    const textEl = document.querySelector('#topbanner-bar .container');
    if (!textEl) return;

    bar.style.color = data.text_color;
    bar.style.backgroundColor = data.background_color;
    textEl.innerHTML = data.content;
    bar.style.display = 'block';
}

function mothersDayBar() {
    const bar = document.getElementById('mothers-day-bar');

    if (!wrapper || !bar) return; // The bar doesnt' exist on the page

    // Dates
    const date       = new Date(year, 4, 7); // months start with 0, so 4 is May
    const mothersDay = moment(date.setDate(7 + (7 - date.getDay())));
    const dayBefore  = moment(mothersDay).subtract(1, 'day');
    const weekBefore = moment(mothersDay).subtract(6, 'day');
    const start      = moment(mothersDay).subtract(16, 'day');
    const end        = moment(mothersDay).add(2, 'day').endOf('day');

    // Temp remove the bar -> Should be removed after 2020-05-12
    if(moment().isSame(moment(new Date(2020, 4, 11)), 'day')) {
        return;
    }
    if(moment().isSame(moment(new Date(2020, 4, 12)), 'day')) {
        return;
    }

    // Don't show if:
    // user has closed the bar before OR
    // "NOW" is not between 1st - 16th Feb
    if (localStorage.getItem('mothers-cta-bar') === key) return;
    if (!moment().isBetween(start, end)) return;

    // Display the bar
    displayBar(bar);

    if (moment().isBetween(mothersDay, end)) {
        setContent(
            '.mothers-day-text', mothersDay,
            translate('I dag er det Mors dag. Husk at bestille blomster til mor! Klik her'),
            translate('Glemte du Mors Dag? Red den gode stemning med blomster og vin/chokolade! Klik her')
        );

        return;
    }

    if (moment().isBetween(weekBefore, mothersDay)) {
        setContent(
            '.mothers-day-text', dayBefore,
            translate('Husk: Det er Mors Dag i morgen. Bestil blomster og chokolade! Klik her'),
            translate('Mors Dag er på Søndag. Bestil både blomster og chokolade allerede i dag! Klik her'),
        );
    }

    addCloseEvent(
        bar,
        document.getElementById('close-mothers-day-cta-bar'),
        getInterval(mothersDay, document.getElementById('mothers-day-timer')),
        'mothers-cta-bar'
    );
}

function setContent(query, sameDay, text1, text2) {
    const textEl = document.querySelector(query);
    if (!textEl) return;

    textEl.innerHTML = moment().isSame(sameDay, 'day')
        ? text1
        : text2;
}

function getInterval(date, timer) {
    const x = setInterval(function () {

        const dur = moment.duration(date.diff(moment()));

        var days    = Math.floor(dur / (1000 * 60 * 60 * 24));
        var hours   = Math.floor(
            (dur % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((dur % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((dur % (1000 * 60)) / 1000);

        if (timer) {
            timer.innerHTML = `${days} dage ${hours} timer ${minutes} minutter ${seconds} sekunder`;
        }

        if (seconds < 0) {
            clearInterval(x);
            if (timer) timer.innerHTML = "";
        }
    }, 1000);

    return x;
}

function displayBar(bar) {
    if (!wrapper || !bar) return;

    wrapper.classList.add('has-cta-bar');
    bar.style.display = 'block';
}

function hideBar(bar) {
    if (!wrapper || !bar) return;

    wrapper.classList.remove('has-cta-bar');
    bar.style.display = 'none';
}

function addCloseEvent(bar, button, interval, storageKey) {
    if (!button || !button.addEventListener) return;

    button.addEventListener('click', function (e) {
        e.preventDefault();
        hideBar(bar);
        clearInterval(interval);
        localStorage.setItem(storageKey, key);
    });
}

module.exports = {
    topbanner,
    valentinesBar,
    mothersDayBar,
};
